import moment from 'moment';

import { ScreenerEtfBackendModel } from "./model";

const apiBaseUrl = process.env.REACT_APP_INTEGRATION_SCREENER_URI!;

export const ScreenerEtfService = {
	etfs: async (): Promise<ScreenerEtfBackendModel[]> => {
		const response = await fetch(apiBaseUrl);
		const parsedBody = await response.json();

		const etfs = parsedBody as any[];
		etfs.forEach(x => x.tradingStartDate = moment(x.tradingStartDate, 'YYYY-MM-DD').toDate())

		return parsedBody;
	}
}
